import { LabelId, UserCommunication } from '@this+that/models';

import { LabelTabConfig } from '../types';

export const LABEL_TABS_CONFIG: LabelTabConfig[] = [
  {
    id: 'labels',
    labelKey: 'inbox.labels.tabs.labels',
    ariaControls: 'labels-filtered-panel',
    ariaLabelledBy: 'labels-filtered-tab',
  },
] as const;

export const LABEL_TABS_ARIA = {
  TAB_LIST_LABEL: 'inbox.labels.tabs.aria.tabListLabel',
  TAB_LIST_DEFAULT: 'Labels filter tabs',
} as const;

export const LABEL_TAB_IDS = {
  LABELS: 'labels',
} as const;

export const LABEL_PREFIXES = {
  GMAIL_LABEL: 'Label_',
} as const;

export const SPECIAL_LABEL_IDS = {
  ALL_LABELS: '__all__',
} as const;

export const filterByLabels = (
  communications: UserCommunication[],
  labelIds: string[],
): UserCommunication[] => {
  if (labelIds.length === 0) {
    return [];
  }

  return communications.filter((communication) => {
    const commLabelIds = communication.labelIds || [];
    return labelIds.some((labelId) =>
      commLabelIds.includes(labelId as LabelId),
    );
  });
};
